
// https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
// https://stackoverflow.com/questions/58624200/react-hook-useeffect-has-a-missing-dependency-dispatch
import React from 'react';
import { useDispatch } from 'react-redux';
import { Menu, Dropdown } from 'antd';
import Flags from 'country-flag-icons/react/3x2'
// import REDUX_UserConfig from '../../objects/UserConfig/reducer'
import { errorCatch, GET, POST, useAuth, useLanguageContext } from 'fennec-ui';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
var _ = require('lodash');

function LangSwitch({ userConfig, onChange }) {
    const auth = useAuth();
    const dispatch = useDispatch();
    const [language, setLanguage] = useLanguageContext();

    const { i18n } = useTranslation()

    const onChangeLang = (value) => {
        GET(auth, `/papi/language/${value}`, () => {
            setLanguage({lang: value})
        }, errorCatch)
        // POST(auth, "/api/setuserconfig", {
        //     key: "lang",
        //     value: value
        // }, ({ data }) => {
        //     var arr = [data];
        //     var obj = Object.fromEntries(arr.map(i => {
        //         return [
        //             i.key,
        //             i.value
        //         ]
        //     }));
        //     let o = REDUX_UserConfig.actions.setObject({ ...userConfig, ...obj });
        //     dispatch(o);
        //     if (onChange) {
        //         onChange(obj);
        //     }
        // }, errorCatch);
    };

    useEffect(()=>{
        i18n.changeLanguage(language?.lang||"ru")
    }, [language])

    return (
        <div style={{ padding: "0px 15px" }}>
            <Dropdown overlay={<Menu selectable={true} selectedKeys={(language && language.lang) ? [language.lang] : []}>
                <Menu.Item key="ru" onClick={() => onChangeLang("ru")}>
                    <div><Flags.RU title="Русский" style={{ width: "20px" }} /> Русский</div>
                </Menu.Item>
                <Menu.Item key="en" onClick={() => onChangeLang("en")}>
                    <div><Flags.US title="English" style={{ width: "20px" }} /> English</div>
                </Menu.Item>
                <Menu.Item key="es" onClick={() => onChangeLang("es")}>
                    <div><Flags.ES title="Español" style={{ width: "20px" }} /> Español</div>
                </Menu.Item>
                <Menu.Item key="tr" onClick={() => onChangeLang("tr")}>
                    <div><Flags.TR title="Türkçe" style={{ width: "20px" }} /> Türkçe</div>
                </Menu.Item>
            </Menu>}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    {(language && language.lang) && <div>
                        {language.lang === 'ru' && <div>
                            <span><Flags.RU title="Русский" style={{ width: "20px" }} /> </span>
                            <span>{language.lang.toUpperCase()}</span>
                        </div>}
                        {language.lang === 'en' && <div>
                            <span><Flags.US title="English" style={{ width: "20px" }} /> </span>
                            <span>{language.lang.toUpperCase()}</span>
                        </div>}
                        {language.lang === 'es' && <div>
                            <span><Flags.ES title="Español" style={{ width: "20px" }} /> </span>
                            <span>{language.lang.toUpperCase()}</span>
                        </div>}
                        {language.lang === 'tr' && <div>
                            <span><Flags.TR title="Türkçe" style={{ width: "20px" }} /> </span>
                            <span>{language.lang.toUpperCase()}</span>
                        </div>}
                    </div>}
                    {(!language || (language && !language.lang)) && <div>
                        <span><Flags.RU title="Русский" style={{ width: "20px" }} /> </span>
                        <span>RU</span>
                    </div>}
                </a>
            </Dropdown>
        </div>
    );
};

export default LangSwitch;
// LangSwitch.whyDidYouRender = true